export default "__VITE_ASSET__BVgJZBr8__"